import { type FC, type MutableRefObject } from "react";
import type { WidgetContent } from "../../../types";
import { GridItemContainer } from "../../GridItemContainer";
import styles from "../styles.module.scss";

type Props = {
  currentWidget: WidgetContent;
  itemRefs: MutableRefObject<HTMLDivElement[]>;
  index: number;
};

export const GridItemMobile: FC<Props> = ({ currentWidget, itemRefs, index }) => {
  return (
    <GridItemContainer
      ref={(el) => {
        if (!el) return;
        itemRefs.current[index] = el;
      }}
      title={currentWidget.title}
    >
      <div className={styles["grid-item-content"]}>{currentWidget.content({})}</div>
    </GridItemContainer>
  );
};
